import * as React from 'react';


export interface SideMenuItem {
  iconClass: string;
  text: string;
  isActive: Boolean;
  onClick: (e: any) => any;
};


const SideMenuItemComponent = ({iconClass, text, isActive, onClick}) => {
  return (
    <a href="javascript:void(null)" className={'side__nav__anch' + (isActive ? ' active': '')} onClick={onClick}>
      <span className={'i ' + iconClass}></span>
      <span className="side__nav__anch__text">{text}</span>
    </a>
  );
};


// TODO: User section
export default ({items, bottom}: {items: SideMenuItem[], bottom?: any}) => {
  return (
    <div className="side__cont">
      <a href="javascript:void(null)" className="side__logo">
        <img src="/assets/img/placeholder/logo-alt.svg" alt="" />
      </a>
      <div className={`side__nav ${bottom ? '--bottom' : ''}`}>
        {items.map((item) => (
          <SideMenuItemComponent
            key={item.text}
            iconClass={item.iconClass}
            text={item.text}
            isActive={item.isActive}
            onClick={item.onClick}
          />
        ))}
      </div>

      {/*
      <div className="side__user">
        <div className="side__user__img">
          <img src="/assets/img/placeholder/user.jpg" alt="" />
        </div>
      </div>
      */}
    </div>
  );
};
